import { SelectedSystemType } from 'data/types';
import { isPtacSelectedSystem } from 'utils/ptac-selected-system';

export const BASELINE_SEER = 14;

type OperatingCostSystem = Pick<
  SelectedSystemType,
  'totalAnnualCost' | 'averageSeer' | 'tags'
>;

export function estimateOperatingCostAtSeer(
  currentOperatingCost: number,
  currentSeer: number,
  newSeer: number
): number {
  return currentOperatingCost * (currentSeer / newSeer);
}

export function estimatedBaselineSeerOperatingCost(
  system: OperatingCostSystem
): number | null {
  if (isPtacSelectedSystem(system)) return null;
  if (!system.totalAnnualCost || !system.averageSeer) return null;
  return estimateOperatingCostAtSeer(
    system.totalAnnualCost,
    system.averageSeer,
    BASELINE_SEER
  );
}
